module.exports = __webpack_public_path__ + "static/media/treasure-box.ff15421b.svga";